<template>
  <div class="outmain heighthv pad_20 bor_rad5 ba_f">
    <div class="ba_f">
      <div class="shuju_title mar_b20">
        <div class="shuju_title_text">
          <span>{{ $t('store.list.title') }}</span>
        </div>
      </div>
      <el-form style="min-width: 1000px;" :inline="true" :model="formInline">
        <el-form-item :label="$t('common.merchantName')" class="mar_l20">
          <el-input style="width: 200px;" v-model="formInline.storeName" :placeholder="$t('common.merchantNamePh')" @input="onSearch"></el-input>
        </el-form-item>
        <el-form-item :label="$t('common.storeNo')" class="mar_l20">
          <el-input style="width: 200px;" v-model="formInline.keyword" :placeholder="$t('common.merchantCodePh')" @input="onSearch"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch" size="medium">{{ $t('common.filter') }}</el-button>
        </el-form-item>
      </el-form>
      <div class="t_l mar_b20">
        <el-button type="primary" @click="handleEdit(false)">{{ $t('store.list.addStore') }}</el-button>
      </div>
    </div>
    <el-table v-loading="listLoading" :element-loading-text="loadingText" :data="list" stripe style="width: 100%;" @selection-change="setSelectRows">
      <el-table-column prop="id" label="ID" width="60"></el-table-column>
      <el-table-column prop="storeName" :label="$t('store.list.storeName')"></el-table-column>
      <el-table-column prop="tel" :label="$t('common.contact')"></el-table-column>
      <el-table-column prop="address" :label="$t('common.storeAddress')"></el-table-column>
      <el-table-column :label="$t('common.storeApiInfo')" min-width="250">
        <template slot-scope="scope">
          <div class="flex">
            <section class="debug-d debug-small" style="background: #67c23a;"></section>
            <span>{{ $t('common.merchantNo') + scope.row.appId }}</span>
          </div>
          <div class="flex mar_t20">
            <section class="debug-d debug-small" style="background: #FF8000;"></section>
            <span style="min-width: 80px;">AppSecret?</span>
            <div v-if="IsEyeShow.indexOf(scope.$index) >= 0" style="padding-right: 16px;">{{ scope.row.appSecret }}</div>
            <div v-else style="font-size: 24px;padding-right: 16px;">************</div>
            <i class="iconfont iconyanjing" :class=" IsEyeShow.indexOf(scope.$index) >= 0 ? 'iconyanjing1' : 'iconyanjing'" style="font-size: 16px;" @click="handIsEyeShow(scope.$index)"></i>
          </div>
          <div class="flex mar_t20">
            <section class="debug-d debug-small" style="background: #2a75ed;"></section>
            <span>AppKey?{{ scope.row.appKey }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="orderNum" :label="$t('common.orderCountDispatch')" min-width="100">
        <template slot-scope="scope">
          <div class="flex">
            <section class="debug-d debug-trip" style="background: #2a75ed;">{{ $t('common.today') }}</section>
            <span>?</span>
            <span>{{ scope.row.orderNum }}</span>
          </div>
          <div class="flex mar_t20">
            <section class="debug-d debug-trip" style="background: #FF8000;">{{ $t('common.total') }}</section>
            <span>?</span>
            <span>{{ scope.row.orderNum }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="balance" :label="$t('common.balance')"></el-table-column>
      <el-table-column prop="createdAt" :label="$t('common.addTime')" min-width="130" align="center"></el-table-column>
      <el-table-column :label="$t('common.operation')" fixed="right" width="200" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.row.id)">{{ $t('common.detail') }}</el-button>
          <el-button type="text" @click="recharge(scope.row)">{{ $t('common.recharge') }}</el-button>
          <el-button type="text" @click="addRule(scope.row)">{{ $t('common.pricingRule') }}</el-button>
          <el-button type="text" @click="handleDelete(scope.row)">{{ $t('common.delete') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background layout="prev, pager, next" :total="page.total" :page-size="page.size" :current-page.sync="page.currentPage" @current-change="handleCurrentChange"></el-pagination>
    <el-dialog :title="$t('common.rechargeDialog')" :visible.sync="dialogVisible" width="800px" :close-on-click-modal="false" @close="close">
      <el-form ref="form" :model="form" label-width="180px">
        <el-form-item :label="$t('common.rechargeAmount')" prop="money" :required="true">
          <el-input v-model.trim="form.money" autocomplete="off" :placeholder="$t('common.rechargeAmountPh')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('common.remark')" prop="note" :required="true">
          <el-input v-model.trim="form.note" autocomplete="off" :placeholder="$t('common.remarkPh')"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="close">{{ $t('common.cancel') }}</el-button>
        <el-button size="medium" type="primary" @click="save">{{ $t('common.confirm') }}</el-button>
      </div>
    </el-dialog>
    <edit ref="edit" @fetchData="fetchData"></edit>
  </div>
</template>
<script>
import Edit from './components/edit';
import { storeList, recharge, deleteStore } from '@/api/store';
export default {
  components: { Edit },
  data() {
    return {
      IsEyeShow: [],
      formInline: {
        storeType: '',
        storeName: '',
        openType: '',
        keyword: ''
      },
      form: {
        money: '',
        note: ''
      },
      value: '',
      dialogVisible: false,
      list: [],
      listLoading: true,
      selectRows: '',
      page: {
        total: 0,
        size: 10,
        currentPage: 1
      }
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    handIsEyeShow(msg) {
      if (this.IsEyeShow.indexOf(msg) < 0) {
        this.IsEyeShow.push(msg);
      } else {
        this.IsEyeShow.splice(this.IsEyeShow.indexOf(msg), 1);
      }
    },
    setSelectRows(val) {
      this.selectRows = val;
    },
    addRule(row) {
      this.$router.push(`/valuerule?id=${row.id}`);
    },
    handleEdit(id) {
      if (id) {
        this.$router.push({
          name: 'storelistInfoEdit',
          query: { id }
        });
      } else {
        this.$refs.edit.showEdit();
      }
    },
    handleDelete(row) {
      if (row.id) {
        this.$baseConfirm(this.$t('confirm.deleteItem'), null, async () => {
          const { msg } = await deleteStore({ id: row.id });
          this.$baseMessage(msg, 'success');
          this.fetchData();
        });
      }
    },
    recharge(row) {
      this.dialogVisible = true;
      this.form.id = row.id;
    },
    async save() {
      const { msg } = await recharge(this.form);
      this.$baseMessage(msg, 'success');
      this.fetchData();
      this.close();
    },
    close() {
      this.$refs['form'].resetFields();
      this.form = this.$options.data().form;
      this.dialogVisible = false;
    },
    onSearch() {
      this.fetchData();
    },
    async fetchData() {
      var params = {
        page: this.page.currentPage
      };
      if (this.formInline.storeName) {
        params.storeName = this.formInline.storeName;
      }
      if (this.formInline.keyword) {
        params.appId = this.formInline.keyword;
      }
      const { data, count } = await storeList(params);
      this.list = data;
      this.page.total = count;
      this.listLoading = false;
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.fetchData();
    }
  }
};
</script>
